import { useState, useRef } from 'react'
import styled from '@emotion/styled'
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import botAPI, { updateBotNotes } from 'api/bot-api'

const Cell = styled.div`
  max-width: 200px;
  width: max-content;
  overflow: auto;
  text-align: left;

  .MuiInputBase-root {
    padding: 5px;
    min-height: 58px;
    align-items: baseline;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiInputAdornment-root {
    flex-direction: column;
    height: auto;
    width: 24px;
    margin: 0;
  }

  .MuiButtonBase-root {
    padding: 0;
    margin: 0;
  }
`

export const NotesCell = ({ id, botId, value, botsQueryKey }) => {
  const [edited, setEdited] = useState(false)
  const [loading, setLoading] = useState(false)
  const inputRef = useRef()

  const cancel = () => {
    setEdited(false)
    inputRef.current.value = value
  }

  const submit = async () => {
    setLoading(true)

    try {
      await botAPI.updateBotNotes(id, inputRef.current.value)
      await updateBotNotes(botId, inputRef.current.value, botsQueryKey)
    } catch (e) {
      console.log(e)
      cancel()
    } finally {
      setEdited(false)
      setLoading(false)
    }
  }

  return <Cell>
    <TextField
      multiline
      disabled={loading}
      defaultValue={value}
      maxRows={8}
      variant="outlined"
      inputRef={inputRef}
      InputProps={{
        onFocus: () => setEdited(true),
        endAdornment: edited && (
          <InputAdornment position="end">
            <IconButton
              onClick={submit}
              edge="end"
            >
              <CheckIcon />
            </IconButton>
            <IconButton
              onClick={cancel}
              edge="end"
            >
              <CancelIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  </Cell>
}
